/**
 * Constantes centralizadas para chaves do localStorage
 * Todas as chaves devem ser definidas aqui para evitar erros de digitação
 * e facilitar manutenção
 */
export const STORAGE_KEYS = {
  // Autenticação
  AUTH_TOKEN: 'authToken',
  USER_ID: 'user_id',
  USER_EMAIL: 'userEmail',

  // Carrinho e Pedidos
  CARRINHO_ID: 'carrinho_id',
  CARRINHOS_LIST: 'carrinhos_list',
  PEDIDO_ID: 'pedido_id',

  // Produtos Selecionados
  SELECTED_PRODUCTS_MANUAL: 'selectedProducts_manual',
  SELECTED_PRODUCTS_CAROLINO: 'selectedProducts_carolino',
  SELECTED_PRODUCTS_ESSENCIAL: 'selectedProducts_essencial',
  SELECTED_PRODUCTS_CLASSICO: 'selectedProducts_classico',
  SELECTED_PRODUCTS_BASICO: 'selectedProducts_basico',
  SELECTED_PRODUCTS_ESPECIAL: 'selectedProducts_especial',
  CONFIRMED_SUGGESTION: 'confirmedSuggestion',

  // Dados do Evento
  CEP: 'cep',
  CEP_DATA: 'cepData',
  ENDERECO_DATA: 'enderecoData',
  DISTANCIA: 'distancia',
  EVENT_TYPE: 'eventType',
  PESSOAS: 'pessoas',

  // Serviços e Informações Finais
  ADDITIONAL_SERVICES: 'additionalServices',
  FINAL_INFO: 'finalInfo',
  FINAL_DATETIME: 'finalDateTime',
  FINAL_NOTES: 'finalNotes',
  COPEIRA_OVERRIDE: 'copeira_override',
  BEST_ESTABLISHMENT_ID: 'best_establishment_id',

  // Outros
  REACT_USE_CART: 'react-use-cart',

  // Flags de controle
  WAS_REFRESHED: 'was_refreshed',

  // Duplicação de orçamento
  DUPLICACAO_ATIVA: 'duplicacao_ativa',
  DUPLICACAO_EVENTOS: 'duplicacao_eventos',
  DUPLICACAO_PEDIDO_ORIGEM: 'duplicacao_pedido_origem',
  EVENTO_EM_EDICAO: 'evento_em_edicao',
  MODO_EDICAO_DUPLICACAO: 'modo_edicao_duplicacao',
  DUPLICACAO_EVENTO_EDITANDO_ID: 'duplicacao_evento_editando_id',
  NOVO_EVENTO_EM_CRIACAO: 'novo_evento_em_criacao',
} as const;

/**
 * Chaves relacionadas ao fluxo de orçamento que devem ser limpas juntas
 */
export const BUDGET_FLOW_KEYS = [
  STORAGE_KEYS.SELECTED_PRODUCTS_MANUAL,
  STORAGE_KEYS.SELECTED_PRODUCTS_CAROLINO,
  STORAGE_KEYS.SELECTED_PRODUCTS_ESSENCIAL,
  STORAGE_KEYS.SELECTED_PRODUCTS_CLASSICO,
  STORAGE_KEYS.SELECTED_PRODUCTS_BASICO,
  STORAGE_KEYS.SELECTED_PRODUCTS_ESPECIAL,
  STORAGE_KEYS.CONFIRMED_SUGGESTION,
  STORAGE_KEYS.CEP,
  STORAGE_KEYS.CEP_DATA,
  STORAGE_KEYS.ENDERECO_DATA,
  STORAGE_KEYS.DISTANCIA,
  STORAGE_KEYS.ADDITIONAL_SERVICES,
  STORAGE_KEYS.FINAL_INFO,
  STORAGE_KEYS.FINAL_DATETIME,
  STORAGE_KEYS.FINAL_NOTES,
  STORAGE_KEYS.EVENT_TYPE,
  STORAGE_KEYS.PESSOAS,
  STORAGE_KEYS.COPEIRA_OVERRIDE,
  // Dados de duplicação também devem ser limpos no refresh
  STORAGE_KEYS.DUPLICACAO_ATIVA,
  STORAGE_KEYS.DUPLICACAO_EVENTOS,
  STORAGE_KEYS.DUPLICACAO_PEDIDO_ORIGEM,
  STORAGE_KEYS.EVENTO_EM_EDICAO,
  STORAGE_KEYS.MODO_EDICAO_DUPLICACAO,
  STORAGE_KEYS.DUPLICACAO_EVENTO_EDITANDO_ID,
] as const;

/**
 * Chaves de autenticação que devem ser limpas juntas
 */
export const AUTH_KEYS = [
  STORAGE_KEYS.AUTH_TOKEN,
  STORAGE_KEYS.USER_ID,
  STORAGE_KEYS.USER_EMAIL,
] as const;
